import React, { Fragment, useState, useRef, useEffect } from "react";
import _ from "lodash";
import { useAuth } from "../../../context/AuthContext";
import EditRegisterFields from "./EditRegisterFields";
import orderFormFields from "./orderFormFields";
import { useSalePackageOptions } from "../Items/SalePackageItems/salePackageCatalog";

export const OrderEditForm = ({
  onChange,
  initailValues,
  fileNames,
  defaultfiles,
  onViewFile,
  warrantyEnd,
  warrantyStart,
  receiptDate,
  warrantyStartEditable = true,
}) => {
  const inputRef = useRef({});
  const [salePackage, setSalePackage] = useState(initailValues.salePackage || "");
  useEffect(() => {
    setSalePackage(initailValues.salePackage || "");
  }, [initailValues.salePackage]);
  const catalog = useSalePackageOptions(salePackage);
  const { currentUser } = useAuth();
  // console.log(warrantyEnd);
  // console.log(warrantyStart);
  // console.log(receiptDate);
  const renderFields = () => {
    return _.map(
      orderFormFields,
      ({ label, name, type, options, required, description, disabled }) => {
        return (
          <EditRegisterFields
            key={name}
            name={name}
            label={label}
            type={type}
            value={
              name === "warrantyEndDate"
                ? warrantyEnd
                  ? new Date(warrantyEnd).toLocaleDateString("fr-CA", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                  : initailValues[name].toDate().toLocaleDateString("en-CA")
                : name === "warrantyStartDate"
                ? warrantyStart
                  ? new Date(warrantyStart).toLocaleDateString("fr-CA", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                  : initailValues[name].toDate().toLocaleDateString("en-CA")
                : name === "receiptDate"
                ? receiptDate
                  ? new Date(receiptDate).toLocaleDateString("fr-CA", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                  : initailValues[name].toDate().toLocaleDateString("en-CA")
                : inputRef.current[name]
            }
            options={name === "salePackage" ? catalog.options : options}
            required={required}
            initailValue={
              type !== "date"
                ? initailValues[name]
                : initailValues[name]
                ? initailValues[name].toDate().toLocaleDateString("en-CA")
                : ""
            }
            disabled={
              name === "salePackage"
                ? catalog.disabled
                : name === "hn" || name === "refHospital" || name === "refCustomer"
                ? true
                : name === "warrantyEndDate"
                ? true
                : name === "warrantyStartDate"
                ? !warrantyStartEditable
                : disabled
            }
            fileNames={fileNames}
            defaultfiles={defaultfiles}
            onChange={(event) => {
              if (name === "salePackage") setSalePackage(event.target.value);
              onChange(name)(event);
            }}
            onViewFile={onViewFile}
            description={name === "salePackage" ? catalog.message : description}
          />
        );
      }
    );
  };

  return <Fragment>{renderFields()}</Fragment>;
};
